import React, { Component } from 'react'
import PropTypes from 'prop-types'

export default function(WrappedComponent) {
  class Container extends Component {
    static displayName = 'FeedbackModalContainer'

    static propTypes = {
      close: PropTypes.func.isRequired,
      hasError: PropTypes.bool.isRequired,
      isPending: PropTypes.bool.isRequired,
      sendFeedback: PropTypes.func.isRequired,
      user: PropTypes.object.isRequired,
    }

    state = {
      feedback: '',
      feedbackType: '',
      subject: '',
    }

    handleDropdownFeedbackTypeSelect = (e, { value: feedbackType }) => {
      this.setState({ feedbackType })
    }

    handleInputChange = (e, { name, value }) => {
      this.setState({ [name]: value })
    }

    handleSubmit = e => {
      const { feedback, feedbackType, subject } = this.state
      const { sendFeedback, user } = this.props

      e.preventDefault()
      sendFeedback(subject, feedback, feedbackType, user)
    }

    render() {
      return (
        <WrappedComponent
          close={this.props.close}
          feedback={this.state.feedback}
          feedbackType={this.state.feedbackType}
          handleDropdownFeedbackTypeSelect={this.handleDropdownFeedbackTypeSelect}
          handleInputChange={this.handleInputChange}
          handleSubmit={this.handleSubmit}
          hasError={this.props.hasError}
          isPending={this.props.isPending}
          subject={this.state.subject}
        />
      )
    }
  }

  return Container
}
